
import React, { useEffect, useState } from 'react'
import { Divider, Grid, Header, Button } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import "./GuestsTab.css"
import { SetGuestsList, ChangeGuestCount } from '../../../../redux/actions/mainActions';

const GuestsTab = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()

    const guests = useSelector((state) => state.main.guests)

    useEffect(() => {
        setGuests()
    }, [guests])
    const setGuests = () => {
        var guestList = ""
        for (let index in guests) {
            if (guests[index].count > 0) {

                guestList += guests[index].count + " " + t(`home:${guests[index].title}`) + " / "

            }
        }
        dispatch(SetGuestsList(guestList))
    }

    const incCountHandler = (index) => {
        var tempCount = guests[index].count
        tempCount = tempCount + 1
        dispatch(ChangeGuestCount(index, tempCount))
    }
    const decCountHandler = (index) => {
        var tempCount = guests[index].count
        if ((tempCount - 1) == 0 || tempCount == 0) {
            tempCount = 0
        } else {
            tempCount = tempCount - 1
        }
        dispatch(ChangeGuestCount(index, tempCount))

    }
    return (

        guests.map((item, index) => {
            return <div key={index} className="m-1-t m-1-b">
                <div className="d-flex flex-row align-items-center justify-content-between ">
                    <Header size='tiny' className='m-0'>
                        {t(`home:${item.title}`)}
                        <Header.Subheader>
                            {t(`home:${item.description}`)}
                        </Header.Subheader>
                    </Header>
                    <div className="d-flex flex-row align-items-center">
                        <Button basic circular className="p-05" color="blue" icon='plus' onClick={() => incCountHandler(index)} />

                        <span className="p-05">{item.count}</span>
                        <Button basic circular className="p-05"  color="blue" icon='minus' onClick={() => decCountHandler(index)} />

                    </div>
                </div>
                {
                    index === guests.length-1 ? null : <Divider className="border-dashed"/> 
                }
            </div>
        })
    )


}
export default GuestsTab